import React, { useState } from 'react';
import { Tabs, Tab, Box, Typography, Paper } from '@material-ui/core';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import WebhookIcon from '@mui/icons-material/Webhook';
import ApiKeys from './ApiKeys';
import Webhooks from './Webhooks';

function TabPanel({ children, value, index }) {
  return value === index ? <Box pt={3}>{children}</Box> : null;
}

export default function Integration() {
  const [tab, setTab] = useState(0);

  return (
    <div style={{ padding: 16 }}>
      <Paper elevation={1}>
        <Tabs
          value={tab}
          onChange={(e, v) => setTab(v)}
          indicatorColor="primary"
          textColor="primary"
          style={{ borderBottom: '1px solid #e0e0e0' }}
        >
          <Tab icon={<VpnKeyIcon />} label="API Keys" style={{ minWidth: 140 }} />
          <Tab icon={<WebhookIcon />} label="Webhooks" style={{ minWidth: 140 }} />
        </Tabs>
        <Box p={2}>
          <TabPanel value={tab} index={0}>
            <ApiKeys />
          </TabPanel>
          <TabPanel value={tab} index={1}>
            <Webhooks />
          </TabPanel>
        </Box>
      </Paper>
    </div>
  );
}
